import { Schema } from "@effect/schema";

export const WarningKey = Schema.Literal("ezEth-dex", "UWU").annotations({
  identifier: "WarningKey",
});

export type WarningKey = typeof WarningKey.Type;
export const warningKeys = WarningKey.literals;
export const isWarningKey = Schema.is(WarningKey);

export type WarningConfig = typeof WarningConfig.Type;
export type WarningConfigEncoded = typeof WarningConfig.Encoded;

export const WarningConfig = Schema.Struct({
  warningKey: WarningKey,
  scope: Schema.Literal("all", "markets", "singleMarket"),
}).annotations({ identifier: "WarningConfig" });
